import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import _ from 'lodash';
import * as React from 'react';
import { LocalizeContextProps, withLocalize } from 'react-localize-redux';
import { connect } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router';
import { Button, ButtonDropdown, DropdownItem, DropdownMenu, DropdownToggle } from 'reactstrap';
import { hasPrivilege } from '../../stores/auth/selectors';
import { RootState } from '../../stores/store';
import { selectedSome } from '../../stores/tables/selectors';
import TableToolbar from '../table/TableToolbar';

import AssignGroupsWorkspaceAction from './actions/AssignGroupsWorkspacesAction';
import CopyGroupAction from './actions/CopyGroupAction';
import DeleteGroupsAction from './actions/DeleteGroupsAction';

interface Props extends LocalizeContextProps, RouteComponentProps {
    selectedSome: boolean;
    hasPrivilege: (privileges: string[]) => boolean;
}

interface State {
    showActions: boolean;
}

class GroupsToolbar extends React.Component<Props, State> {
    public constructor(props: Props) {
        super(props);
        this.state = {
            showActions: false
        };
    }

    public render() {
        const t = this.props.translate;
        return (
            <TableToolbar>
                {this.renderActionMenu()}
                <Button
                    color="primary"
                    className="action-btn"
                    onClick={() => {
                        this.props.history.push(`/groups/new`);
                    }}
                >
                    <FontAwesomeIcon
                        className="mr-4"
                        icon={['fal', 'plus']}
                    />
                    {t('groups.button.add')}
                </Button>
            </TableToolbar>
        );
    }

    private renderActionMenu = () => {
        const t = this.props.translate;
        const menuItems = _.compact(this.renderActions());

        if (menuItems.length > 0) {
            return (
                <ButtonDropdown
                    id="action-buttons"
                    className="action-btn"
                    color="default"
                    title={t('groups.button.actions') as string}
                    isOpen={this.state.showActions}
                    toggle={() => { this.setState({ showActions: !this.state.showActions }); }}
                    style={{ marginRight: '10px' }}
                >
                    <DropdownToggle caret={true}>
                        {t('groups.button.actions')}
                    </DropdownToggle>
                    <DropdownMenu persist={true}>
                        {menuItems}
                    </DropdownMenu>
                </ButtonDropdown>
            );
        } else {
            return <div />;
        }
    }

    private renderActions = () => {
        const t = this.props.translate;
        if (this.props.selectedSome) {
            return (
                [
                    <CopyGroupAction key={1} />, // TODO
                    <AssignGroupsWorkspaceAction key={2} />, // TODO
                    <DeleteGroupsAction key={3} />, // TODO
                ]
            );

        } else {
            return [];
        }
    }
}

const mapStateToProps = (state: RootState) => ({
    hasPrivilege: hasPrivilege(state),
    selectedSome: selectedSome(state, 'groups'),
});

export default connect(mapStateToProps)(withLocalize(withRouter(GroupsToolbar)));